import styled from 'styled-components';
import IconChevronDownCircleOutline from './IconChevronDownCircleOutline';
var IconChevronUpCircleOutline = /*#__PURE__*/styled(IconChevronDownCircleOutline).withConfig({
  displayName: "IconChevronUpCircleOutline",
  componentId: "c11n-8-111-1__sc-152l1fo-0"
})(["transform:rotate(180deg);"]);
export default IconChevronUpCircleOutline;